import React, { useState } from "react";
import { View } from "native-base";
import { DatePickerInput } from "react-native-paper-dates";
import { SafeAreaProvider } from "react-native-safe-area-context";

const DatePickerSingleInput = (props) => {
  const [inputDate, setInputDate] = useState(undefined);

  const onChange = (date) => {
    setInputDate(date);
    props.onChange(convertDate(date));
  };

  const convertDate = (inputFormat) => {
    function pad(s) {
      return s < 10 ? "0" + s : s;
    }
    var d = new Date(inputFormat);
    return [pad(d.getMonth() + 1), pad(d.getDate()), d.getFullYear()].join("/");
  };

  return (
    <SafeAreaProvider>
      <View mt={5}>
        <DatePickerInput
          locale="en-GB"
          value={inputDate}
          onChange={(d) => onChange(d)}
          inputMode="start"
          mode="flat"
          inputEnabled={true}
          endYear="2100"
          uppercase={false}
        />
      </View>
    </SafeAreaProvider>
  );
};

export default DatePickerSingleInput;
